export default __webpack_public_path__ + "static/0058-c722de10e75c68ebe619ada1a088f5fa.png";